import validate from "/vercel/path0/node_modules/.pnpm/nuxt@3.7.3_@netlify+blobs@9.1.2_@parcel+watcher@2.5.1_@types+node@24.1.0_eslint@7.32.0__cb46d35bd36de2f95fd3d33487beb628/node_modules/nuxt/dist/pages/runtime/validate.js";
import utm_45global from "/vercel/path0/middleware/utm.global.ts";
export const globalMiddleware = [
  validate,
  utm_45global
]
export const namedMiddleware = {
  auth: () => import("/vercel/path0/middleware/auth.js")
}